import { PublicationCardItemWithVideo } from '@news-mono/web-common'

/**
 * Ensures a usable '16:9' crop for vertical posters by pointing it to the original asset.
 * UI contract only — we don't mutate global CardMedia or API shapes.
 * Small tolerance protects near-square images from being treated as vertical.
 */
export function patchVerticalThumb(
    item: PublicationCardItemWithVideo,
    tolerance = 1.02,
): PublicationCardItemWithVideo {
    const original = item.image?.crops?.original
    if (!original) return item

    const isVertical = original.height > original.width * tolerance
    if (!isVertical) return item

    const existing = item.image?.crops?.['16:9']
    if (existing?.reference) return item

    return {
        ...item,
        image: {
            ...item.image!,
            crops: {
                ...item.image!.crops,
                '16:9': {
                    reference: original.reference,
                    width: original.width,
                    height: original.height,
                    ratio: { width: 16, height: 9 },
                },
            },
        },
    }
}
